enum UserPermissionEditType {
  Profile = 'Profile',
  Role = 'Role',
  Access = 'Access',
  DocumentType = 'DocumentType',
}
export default UserPermissionEditType;
